const categories_icons = [
    {
        name: "Suppliers",
        relativePath: "microservices/MiFirma/assets/boveda-digital/Suppliers.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Suppliers.svg"
    },
    {
        name: "Reports",
        relativePath: "microservices/MiFirma/assets/boveda-digital/Reports.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Reports.svg"
    },
    {
        name: "Insurance",
        relativePath: "microservices/MiFirma/assets/boveda-digital/Insurance.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Insurance.svg"
    },
    {
        name: "Wills",
        relativePath: "microservices/MiFirma/assets/boveda-digital/Wills.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Wills.svg"
    },
    {
        name: "ShareSecurities",
        relativePath: "microservices/MiFirma/assets/boveda-digital/ShareSecurities.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/ShareSecurities.svg"
    },
    {
        name: "Studies",
        relativePath: "microservices/MiFirma/assets/boveda-digital/Studies.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Studies.svg"
    },
    {
        name: "BankAccounts",
        relativePath: "microservices/MiFirma/assets/boveda-digital/BankAccounts.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/BankAccounts.svg"
    },
    {
        name: "ThirdPartyContracts",
        relativePath: "microservices/MiFirma/assets/boveda-digital/ThirdPartyContracts.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/ThirdPartyContracts.svg"
    },
    {
        name: "IntercompanyContracts",
        relativePath: "microservices/MiFirma/assets/boveda-digital/IntercompanyContracts.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/IntercompanyContracts.svg"
    },
    {
        name: "InsuranceCompanyContracts",
        relativePath: "microservices/MiFirma/assets/boveda-digital/InsuranceCompanyContracts.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/InsuranceCompanyContracts.svg"
    },
    {
        name: "Customers",
        relativePath: "microservices/MiFirma/assets/boveda-digital/Customers.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Customers.svg"
    },
    {
        name: "InsuranceAgentID",
        relativePath: "microservices/MiFirma/assets/boveda-digital/InsuranceAgentID.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/InsuranceAgentID.svg"
    },
    {
        name: "Leases",
        relativePath: "microservices/MiFirma/assets/boveda-digital/Leases.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Leases.svg"
    },
    {
        name: "Assembliessvg",
        relativePath: "microservices/MiFirma/assets/boveda-digital/Assembliessvg.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Assembliessvg.svg"
    },
    {
        name: "Audits",
        relativePath: "microservices/MiFirma/assets/boveda-digital/Audits.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Audits.svg"
    },
    {
        name: "Assets",
        relativePath: "microservices/MiFirma/assets/boveda-digital/Assets.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Assets.svg"
    },
    {
        name: "RealEstate",
        relativePath: "microservices/MiFirma/assets/boveda-digital/RealEstate.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/RealEstate.svg"
    },
    {
        name: "Investments",
        relativePath: "microservices/MiFirma/assets/boveda-digital/Investments.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Investments.svg"
    },
    {
        name: "CorporateBooks",
        relativePath: "microservices/MiFirma/assets/boveda-digital/CorporateBooks.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/CorporateBooks.svg"
    },
    {
        name: "Municipal",
        relativePath: "microservices/MiFirma/assets/boveda-digital/Municipal.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Municipal.svg"
    },
    {
        name: "IndustrialProperty",
        relativePath: "microservices/MiFirma/assets/boveda-digital/IndustrialProperty.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/IndustrialProperty.svg"
    },
    {
        name: "Properties",
        relativePath: "microservices/MiFirma/assets/boveda-digital/Properties.svg",
        url: "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Properties.svg"
    }
]

export default categories_icons